import { render, staticRenderFns } from "./AdminVerdictsCollections.vue?vue&type=template&id=1b15c7e6"
import script from "./AdminVerdictsCollections.vue?vue&type=script&lang=js"
export * from "./AdminVerdictsCollections.vue?vue&type=script&lang=js"
import style0 from "./AdminVerdictsCollections.vue?vue&type=style&index=0&id=1b15c7e6&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b15c7e6')) {
      api.createRecord('1b15c7e6', component.options)
    } else {
      api.reload('1b15c7e6', component.options)
    }
    module.hot.accept("./AdminVerdictsCollections.vue?vue&type=template&id=1b15c7e6", function () {
      api.rerender('1b15c7e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminVerdictsCollections.vue"
export default component.exports